import type { FaireProductEntity } from "../../entity_types/product";

export const p_ds93cazen4: FaireProductEntity = {
  token: "p_ds93cazen4",
  type: "product",
  name: "Coach W Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/16d9e40acc10ed4d1559dcba7454b90da987ca3944d07fce63cd31d25292b26e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55cc11d3f5081c66da760bffccd0802025c39248cd4d9c6301bf8be29e51d63d.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:21.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
